<template>
  <div class="container">
    <section>
      <h2>Lean Canvas</h2>
      <table class="bizcanvas" cellspacing="0" border="1">
        <tbody>
          <tr>
            <td colspan="2">
              <h4>Problem</h4>
              <p>
                <strong>WordPress</strong> and other website builders provides a
                <strong>terrible developer experience</strong> and are holding
                back technical innovate of the web.
              </p>
              <p>
                Website builders are big
                <strong>complicated technology</strong> platforms that are
                difficult to customize and tailor to brand style.
              </p>
              <p>
                Server side rendered websites like WordPress are not ideal for
                reliability and sustainability. They often have
                <strong>server scaling</strong> and hosting management
                headaches.
              </p>
            </td>
            <td colspan="2">
              <h4>Solution</h4>
              <p>
                Innovate marketing websites built with bleeding edge technology.
                Beautifully designed to provide a competitive digital presence
                for start-ups.
              </p>
              <p>
                I want to automate and speed up the process of making
                personalized marketing websites.
              </p>
              <p>
                <strong>Nuxt</strong> is an innovating
                <strong>static site generation</strong>
                framework we use to build websites.
              </p>
            </td>
            <td colspan="2">
              <h4>Value Proposition</h4>
              <p>
                Start ups are busy building their business. They don't want to
                worry about managing a marketing website. I want to provide a
                set and forget experience for them. Making sustainable websites
                that reduce the headache of managing a website.
              </p>
              <p>
                Do it for you rather than do it yourself,
                <strong>affordable</strong>, <strong>stress free</strong>,
                <strong>fully managed websites</strong>.
              </p>
            </td>
            <td colspan="2">
              <h4>Unfair Advantage</h4>
              <p>
                I'm an <strong>entrepreneur</strong> myself and work 80-hour
                weeks for the last 5 years building my skills in both business
                and technology.
              </p>
              <p>
                Being an entrepreneur myself I can empathize with the needs of
                other entrepreneurs.
              </p>
              <p>
                Passion for <strong>open source</strong> and collaboration allow
                me to make wonderful long-lasting industry connections.
              </p>
              <p>"Content is King - Code is Queen ".</p>
            </td>
            <td colspan="2">
              <h4>Customer Segments</h4>
              <p>
                Sole Traders, Start-ups and small business need a digital
                presence. Rather than having them work for their website I want
                to make the website work for them.
              </p>
              <p>
                The smaller the business the more important. I want to help new
                and <strong>micro businesses</strong> compete with the big guys.
              </p>
            </td>
          </tr>
          <tr>
            <td colspan="2">
              <h4>Alternatives</h4>
              <p>
                There are 2 types of alternatives, do it yourself
                <strong>website builders</strong>
                and hiring a <strong>digital agency</strong> to do it for you.
              </p>

              <ul>
                <li>WordPress (43% market share)</li>
                <li>Square Space</li>
                <li>Wix</li>
                <li>Shopify</li>
                <li>Digital Agencies</li>
              </ul>
            </td>
            <td colspan="2">
              <h4>Key Metrics</h4>
              <p>
                Measuring how engaging a web page and, how the page is creating
                revenue generating leads and <strong>conversions</strong>.
              </p>
              <ol>
                <li>Impressions</li>
                <li>Page views</li>
                <li>Page load speed</li>
                <li>Time on page</li>
                <li>Contact form submissions</li>
              </ol>
            </td>
            <td colspan="2">
              <h4>High-level concept</h4>
              <p>
                Custom, bespoke, personalized, tailored
                <strong>web design and development</strong> for
                <strong>start-ups</strong> focused on innovation.
              </p>
              <p>WordPress for start-ups.</p>
              <p>Digital Agency for start-ups.</p>
            </td>
            <td colspan="2">
              <h4>Channels</h4>
              <p>
                Utilizing <strong>social channels</strong> to share content that
                would be relevant and helpful for entrepreneurs. Also connecting
                in person at <strong>networking events</strong>.
              </p>
              <ol style="columns: 2; -webkit-columns: 2; -moz-columns: 2">
                <li>LinkedIn</li>
                <li>Twitter</li>
                <li>Facebook</li>
                <li>Instagram</li>
                <li>Email</li>
                <li>Website</li>
                <li>TikTok?</li>
                <li>Start up Incubators</li>
                <li>Co working spaces</li>
              </ol>
            </td>
            <td colspan="2">
              <h4>Early adopters</h4>
              <p>
                Working with <strong>people I know</strong> and expanding my
                network to find <strong>start-ups</strong> and
                <strong>sole traders</strong> who need a website.
              </p>
              <ol>
                <li>Family &amp; Friends</li>
                <li>Sole Traders</li>
                <li>Start-ups</li>
                <li>Small business</li>
              </ol>
            </td>
          </tr>
          <tr>
            <td colspan="5">
              <h4>Cost Structure</h4>
              <ol>
                <li>Design $2,000 - $5,000 per project</li>
                <li>Developer $1,000 - $5,000 per project (10 - 50 hours)</li>
                <li>Project Manager $200 per project</li>
                <li>Domain name $20 - $400 per year</li>
                <li>Server Hosting $20 - $4000 per month</li>
              </ol>
              <br />
              <p>Total: <strong>$3,240 - $14,400 per project</strong></p>

              <p>
                <strong>Transparency</strong> in costs to provide a premium
                experience.
              </p>
              <p>
                Cost Driven (cost structure, low price prop, maximum automation,
                extensive outsourcing).
              </p>
              <p>
                Value driven (focused on value creation, premium value prop).
              </p>
            </td>
            <td colspan="5">
              <h4>Revenue Streams</h4>
              <p>
                Project based work for initial website builds and the providing
                ongoing support and maintenance.
              </p>
              <table>
                <tbody>
                  <tr>
                    <td>
                      <h5>Reselling</h5>
                      <ol>
                        <li>Domain names</li>
                        <li>Server Hosting</li>
                        <li>SaaS Setup</li>
                      </ol>
                      <br />
                    </td>
                    <td>
                      <h5>Services</h5>
                      <ol>
                        <li>Design</li>
                        <li>Development</li>
                        <li>Marketing</li>
                        <li>Tech Support</li>
                        <li>Project Management</li>
                      </ol>
                    </td>
                  </tr>
                </tbody>
              </table>
            </td>
          </tr>
        </tbody>
      </table>
    </section>
    <br />
    <section>
      <h2>Alex Osterwilder Business Model Canvas</h2>
      <table class="bizcanvas" cellspacing="0" border="1">
        <tbody>
          <!-- Upper part -->
          <tr>
            <td colspan="2" rowspan="2">
              <h4>Key Partners</h4>
              <p>Who are our key partners?</p>
              <p>Who are our key suppliers?</p>
              <p>Which key resources are we acquiring from partners?</p>
              <p>Which key activities our partners perform?</p>
              <p><strong>Motivation for partnerships</strong></p>
              <p>
                Optimization and economy <br />
                Reduction of risk and uncertainty <br />
                Acquisition of particular resources and activities <br />
              </p>
            </td>
            <td colspan="2">
              <h4>Key Activities</h4>
              <p>What key activities do our value propositions require?</p>
              <p>Our distribution channels?</p>
              <p>Customer relationships?</p>
              <p>Revenue Streams?</p>
              <p><strong>Categories</strong></p>
              <p>
                Production <br />
                Problem Solving <br />
                Platform/Network <br />
              </p>
            </td>
            <td colspan="2" rowspan="2">
              <h4>Value Proposition</h4>
              <p>Which value do we deliver to the customer?</p>
              <p>
                Which one of our customer's problems are we helping to solve?
              </p>
              <p>
                What bundles of products and services are we offering to each
                customer segment?
              </p>
              <p>Which customer needs are we satisfying?</p>
              <p><strong>Characteristics</strong></p>
              <p>
                Newness <br />
                Performance <br />
                Customization <br />
                "Getting Job Done" <br />
                Design <br />
                Brand/Status <br />
                Price <br />
                Cost Reduction <br />
                Risk Reduction <br />
                Accessibility <br />
                Convenience/Usability <br />
              </p>
            </td>
            <td colspan="2">
              <h4>Customer Relationship</h4>
              <p>What type of relationship each customer segment expects?</p>
              <p>Which ones have we established?</p>
              <p>How are they integrated with rest of the biz. model?</p>
              <p>How much they cost us?</p>
              <p><strong>Examples</strong></p>
              <p>
                Personal assistance<br />
                Self-service<br />
                Automated services<br />
                Communities<br />
                Co-creation<br />
              </p>
            </td>
            <td colspan="2" rowspan="2">
              <h4>Customer Segments</h4>
              <p>For whom are we creating value?</p>
              <p>Who are our most important customers?</p>
              <p><strong>Examples</strong></p>
              <p>
                Mass market<br />
                Niche market<br />
                Segmented<br />
                Diversified<br />
                Multi-sided platform<br />
              </p>
            </td>
          </tr>

          <!-- Lower part -->
          <tr>
            <td colspan="2">
              <h4>Key Resources</h4>
              <p>What key resources our value proposition requires?</p>
              <p>Our distribution channels? Customer relationships?</p>
              <p>Revenue Streams?</p>
              <p><strong>Types of resources</strong></p>
              <p>
                Physical <br />
                Intellectual (brand, patents, copyrights, data) <br />
                Human <br />
                Financial
              </p>
            </td>
            <td colspan="2">
              <h4>Channels</h4>
              <p>
                Through which channels our customer segments want to be reached?
              </p>
              <p>How are we reaching them now?</p>
              <p>How are channels integrated?</p>
              <p>Which ones work best?</p>
              <p>Which ones are most cost efficient?</p>
              <p>How are we integrating them with customer routines?</p>
            </td>
          </tr>
          <tr>
            <td colspan="5">
              <h4>Cost Structure</h4>
              <p>
                What are most important costs inherent to our business model?
              </p>
              <p>Which key resources are most expensive?</p>
              <p>Which key activities are most expensive?</p>
              <p><strong>Is your business more?</strong></p>
              <p>
                Cost driven(cost structure, low price prop, maximum automation,
                extensive outsourcing)
              </p>
              <p>
                Value driven (focused on value creation, premium value prop)
              </p>
            </td>
            <td colspan="5">
              <h4>Revenue Streams</h4>
              <p>For what value are our customers willing to pay?</p>
              <p>What are they currently paying for?</p>
              <p>How are they paying?</p>
              <p>How would they prefer to pay?</p>
              <p>How much each revenue stream contributes overall?</p>
            </td>
          </tr>
        </tbody>
      </table>
    </section>
    <br />
    <section>
      <h2>Sources</h2>
      <ul>
        <li>
          <a href="https://leanstack.com/lean-canvas"
            >Ash Maurya's Lean Canvas</a
          >
        </li>
        <li>
          <a href="https://www.strategyzer.com/canvas/business-model-canvas"
            >Alex Osterwilder's Business Model Canvas</a
          >
        </li>
        <li>
          <a href="https://codepen.io/harleybarnes/pen/VKWLrL"
            >Codepen | Bootstrap CSS Lean Canvas Template</a
          >
        </li>
        <li>
          <a href="https://github.com/desireco/BusinessModelCanvasTemplate"
            >GitHub | Business Model Canvas Template</a
          >
        </li>
      </ul>
    </section>
  </div>
</template>

<style>
.bizcanvas {
  border: 3px solid black;
  width: 100%;
}

.bizcanvas td {
  vertical-align: top;
  height: 200px;
  width: 200px;
  padding: 6px;
}
</style>
